<template>
  <div class="my-item">
    <div class="pavilion-wrap">
      <template v-if="list && list.length">
        <Table :border="false" :columns="columns1" :data="list" :disabled-hover="false">
          <template slot-scope="{ row, index }" slot="name">{{row.name}}</template>
          <template slot-scope="{ row, index }" slot="showIndex">{{row.showIndex}}</template>
          <template slot-scope="{ row, index }" slot="value">{{row.value}}</template>
          <template slot-scope="{ row, index }" slot="action">
            <span style="color: #1890ff;cursor: pointer;" @click="editShow(row)">编辑</span>
            <span style="display: inline-block;padding: 0 5px;">|</span>
            <Poptip confirm title="确认是否删除?" @on-ok="delItem(row)" :transfer="true">
              <span style="color: #f00;cursor: pointer;">删除</span>
            </Poptip>
          </template>
        </Table>
      </template>
      <div class="u-empty" v-else>暂无数据</div>
    </div>
    <pavilionAdd 
      :show="show" 
      @finish="init()"
      @close="show=false;"
    />
    <pavilionEdit 
      :show="edit" 
      @finish="init()"
      v-if="editInfo"
      :editInfo="editInfo"
      @close="edit=false;editInfo=null"
    />
  </div>
</template>

<script>
import pavilionAdd from "../components/pavilion-add.vue";
import pavilionEdit from "../components/pavilion-edit.vue";
import { mapActions } from "vuex";

export default {
  // 展馆管理
  name: "host-set-pavilion",
  data() {
    return {
      list: [],
      edit: false,
      editInfo: false,
      show: false,  
      columns1: [
        {
          title: "展馆号",
          slot: "name",
          key: "name",
          align: "center"
        },
        {
          title: "排序",
          slot: "showIndex",
          key: "showIndex",
          align: "center"
        },
        {
          title: "描述",
          slot: "value",
          align: "center"
        },
        {
          title: "操作",
          slot: "action",
          align: "center"
        }
      ],
      pageIndex: 1,
      pageSize: 12,
      totalCount: 0,
    };
  },
  computed: {
    exhibitionInfo() {
      if (JSON.parse(localStorage.vuex)) {
        return JSON.parse(localStorage.vuex).hostSetModule.hostExhibition;
      }
    }
  },
  created() {
    this.init();
  },
  components: {
    pavilionAdd, 
    pavilionEdit,
  },
  methods: {
    ...mapActions({
      getPavilion: "hostSetModule/getPavilion",
      delPavilionById: "hostSetModule/delPavilionById",
    }),  
    async init() {
      let listData = await this.getPavilion(this.exhibitionInfo.id); 
      if (listData && listData.length) {
        this.list = listData;
        console.log(this.list)
      }
    }, 
    async delItem(item) { 
      let result = await this.delPavilionById(item.id);
      if (result.successed) {
        this.$Message.success("删除成功");
        this.init();
      } else {
        this.$Message.error("删除失败，请重新尝试");
      }
    },
    showAdd() {
      this.show = true;
    },
    editShow(e) {
      this.edit = true;
      this.editInfo = e;
    },
  }
};
</script>

<style scoped lang="scss">
.pavilion-wrap {
  margin: 0 auto;
  min-height: 500px;
}
</style>
